import HtmlElement from '../../../Elements/HtmlElement';

/**
 * SocialProofBubbles
 */
const SocialProofBubbles = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		SOCIAL_PROOF_BUBBLES: '.cta-social-proof-bubbles'
	};

	/**
	 * SocialProofBubble
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class SocialProofBubbles extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this.$bubbles = this.$element.find('.cta-social-proof-bubble');
			this.currentIndex = 0;
			this.length = this.$bubbles.length;
			this.emojis = this.$element.data('emojis');
			this.delayMin = this.$element.data('delay-min');
			this.delayMax = this.$element.data('delay-max');
			this.customPlace = this.$element.data('place');
			this.customText = this.$element.data('text');

			const randomInterval = () => {
				return Math.max(0, randomInt(this.delayMin, this.delayMax)) * 1000;
			}

			let startTime = null;
			let interval = randomInterval();
			this.bubbleVisible = false;

			const animate = () => {
				if (!startTime) {
					startTime = Date.now();
				}
				const elapsedTime = Date.now() - startTime;

				if (elapsedTime >= interval) {
					if (!this.bubbleVisible) {
						this.showBubble();
						this.bubbleVisible = true;
						setTimeout(() => {
							this.hideBubble();
							this.bubbleVisible = false;
							this.currentIndex = this.getNextIndex();
							interval = randomInterval();
							startTime = Date.now();
						}, 4000);
					}
				}

				requestAnimationFrame(animate);
			};

			animate();
		}

		getNextIndex() {
			if (this.currentIndex + 1 < this.length) {
				return this.currentIndex + 1;
			}

			return 0;
		}

		showBubble() {
			const randomEmoji = this.emojis[Math.floor(Math.random() * this.emojis.length)];
			this.$bubbles.eq(this.currentIndex).find('.cta-social-proof-bubble-emoji').html(`${randomEmoji}<span class="cta-social-proof-bubble-emoji-bg">${randomEmoji}</span>`);
			this.$bubbles.eq(this.currentIndex).addClass('visible');
		}

		hideBubble() {
			const $element = this.$bubbles.eq(this.currentIndex);

			$element.fadeOut(300, () => {
				$element.css('display', '');
				$element.removeClass('visible');
			});
		}
	}

	return SocialProofBubbles._getElements(Selector.SOCIAL_PROOF_BUBBLES, SocialProofBubbles);
})();

function randomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

export default SocialProofBubbles;
